package org.gstechnovos.jexonplastech.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.gstechnovos.jexonplastech.models.Section
import org.gstechnovos.jexonplastech.models.Theme
import org.gstechnovos.jexonplastech.util.Constants
import org.gstechnovos.jexonplastech.util.ObserveViewportEntered
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.unaryMinus
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun SectionTitle(
    modifier: Modifier = Modifier,
    section: Section,
    alignment: Alignment.Horizontal = Alignment.Start,
) {

    val scope = rememberCoroutineScope()

    var titleOffset by remember { mutableStateOf(50.px) }
    var subTitleOffset by remember { mutableStateOf(50.px) }

    var opacity by remember { mutableStateOf(0.0) }

    ObserveViewportEntered(sectionId = section.id, distanceFromTop = 500.0, onViewportEntered = {
        scope.launch {
            subTitleOffset = 0.px
            opacity = 1.0
            if (alignment == Alignment.Start) delay(25)
            titleOffset = 0.px
        }
    })

    Column(modifier = modifier, horizontalAlignment = alignment) {
        P(
            attrs = Modifier.fillMaxWidth().textAlign(
            when (alignment) {
                Alignment.CenterHorizontally -> TextAlign.Center
                Alignment.End -> TextAlign.End
                else -> TextAlign.Start
            }
        ).translateX(if (alignment == Alignment.Start) titleOffset else - titleOffset)
                .opacity(opacity) // Fading in hides any initial jerkiness
                .transition(
                    // 3. Use 'translate' and 'opacity' properties
                    Transition.of("translate", 300.ms, TransitionTimingFunction.EaseOut),
                    Transition.of("opacity", 300.ms, TransitionTimingFunction.EaseOut)
                )
                .fontFamily(Constants.FONT_FAMILY)
                .fontSize(25.px)
                .fontWeight(FontWeight.Normal)
                .color(Theme.Primary.rgb)
                .toAttrs()) {
            Text(section.title)
        }

        P(
            attrs = Modifier.fillMaxWidth().textAlign(
                when (alignment) {
                    Alignment.CenterHorizontally -> TextAlign.Center
                    Alignment.End -> TextAlign.End
                    else -> TextAlign.Start
                }
            ).translateX(
                if (alignment == Alignment.Start) subTitleOffset
                else if (alignment == Alignment.CenterHorizontally) - subTitleOffset
                else subTitleOffset
            )
                .opacity(opacity)
                .transition(
                    Transition.of("translate", 300.ms, TransitionTimingFunction.EaseOut),
                    Transition.of("opacity", 300.ms, TransitionTimingFunction.EaseOut)
                )
                .fontFamily(Constants.FONT_FAMILY)
                .fontSize(40.px)
                .fontWeight(FontWeight.Bold)
                .color(Theme.Secondary.rgb)
                .toAttrs()
        ) {
            Text(section.subtitle)
        }

        Box(
            modifier = Modifier.height(2.px).width(80.px).backgroundColor(Theme.Primary.rgb).borderRadius(50.px)
        )
    }

}